import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import Cookie from 'cookies-js';
import DashboardMobileNav from '../../navigation.components/DashboardMobileNav';
import UserDashBoardSideNavigation from '../userDashBoard.components/UserDashBoardSideNavigation';
import UserDashBoardTopNavigation from '../userDashBoard.components/UserDashBoardTopNavigation';
import { InvestmentCards } from '../../commons/index';

/**
 * @class InvestStartPage
 */
class InvestStartPage extends Component {
  /**
   *
   * @returns {*} - render
   */
  render() {
    const { history } = this.props;

    const getInvestLink = Cookie.get('investLink');
    const investStartPage = (
      <section className="body_space">
        <div className="go_back">
          <span onClick={history.goBack}>
            <i className="fa fa-arrow-left" aria-hidden="true" />
            {' '}
            {'  '}
             Go Back
          </span>
        </div>
        <div className="investment_upper_part">
          <div className="investment_upper_part_title">

            <div className="first_child">
              <h4>
                Investments
              </h4>
              <p>
            Select your investment plan of interest
              </p>
            </div>

            <div className="second_child">
              <div className="second_child_icon" />
              <div className="second_child_input main" />
              <div className="second_child_filter main">
                <div className="filter_dropdown">
                  <i className="fas fa-filter" />
                    Filter
                  <i className="fas fa-angle-down" />
                </div>
                <div className="second_child_filter_dropdown animated bounce">
                  <div className="filter_header">
                    <h6>
                    Filter Investment Plans
                    </h6>
                  </div>
                  <div className="filter_select">
                    <div className="input_div">
                      <p>
                        Start Amount
                      </p>
                      <select
                        name="cars"
                        id="savingFrequencyOption"
                      >
                        <option value="Meep" selected>FIX-TIP</option>
                        <option value="MT-LIP">MT-LIP</option>
                        <option value="REAP">MUTUAL-FUND</option>
                      </select>
                    </div>
                  </div>

                  <div className="filter_select">
                    <div className="input_div">
                      <p>
                        Start Amount
                      </p>
                      <select name="cars"
                        id="savingFrequencyOption"
                      >
                        <option value="volvo" selected>Set Durantion</option>
                        <option value="saab">91</option>
                        <option value="fiat">182</option>
                        <option value="audi">365</option>
                      </select>
                    </div>
                  </div>
                  <div className="input_div">

                    <p>
                   interest
                    </p>

                    <label className="filter_radio_select">
                      5%
                      <input type="radio" name="interest" value="5" checked />
                      <span className="checkmark" />
                    </label>

                    <label className="filter_radio_select">
                        10%
                      <input type="radio" name="interest" value="5" />
                      <span className="checkmark" />
                    </label>

                    <label className="filter_radio_select">
                      15%
                      <input type="radio" name="interest" value="5" />
                      <span className="checkmark" />
                    </label>

                    <label className="filter_radio_select">
                      20%
                      <input type="radio" name="interest" value="5" />
                      <span className="checkmark" />
                    </label>

                    <label className="filter_radio_select">
                       25%
                      <input type="radio" name="interest" value="5" />
                      <span className="checkmark" />
                    </label>
                  </div>

                  <div className="btn_full_width green_btn">
                    <button id="" type="button">
                       Invest
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="invest_products">
            <Link to="/mutual-market-fund">
              <InvestmentCards
                investTitle="Mutual Funds"
                investImage="invest_products_image_three"
                investDescription="This Fund invests in low risk, short-term securities such as Government securities..."
                investInterest="10% monthly"
                investAmount="₦ 10,000.00"
              />
            </Link>

            <Link to="/invest-fix-tip">
              <InvestmentCards
                investTitle="Fixed-Tip"
                investImage="invest_products_image_five"
                investDescription="This is a short-term placement of funds with a guarantee on capital plus a pre-agreed..."
                investInterest="10% monthly"
                investAmount="₦ 200,000.00"
              />
            </Link>
            <Link to="/invest-mtlip">
              <InvestmentCards
                investTitle="MT-LIP"
                investImage="invest_products_image"
                investDescription="This Fund invests in low risk, short-term securities such as Government securities..."
                investInterest="0% monthly"
                investAmount="₦ 200,000.00"
              />
            </Link>
          </div>
        </div>
      </section>
    );
    return (
      <>
        {
          getInvestLink ? (
            <>
              <DashboardMobileNav />
              <UserDashBoardSideNavigation />
              <div className="main_body_wrapper">
                <UserDashBoardTopNavigation />
                { investStartPage }
              </div>
            </>
          ) : investStartPage
        }
      </>
    );
  }
}

export default withRouter(InvestStartPage);
